import { Component, OnInit  } from "@angular/core";
import { AccountService  } from "../../models/account.service";

@Component({
    selector: "ab-invoiced-payment-failed-alert",
    templateUrl: "./invoiced-payment-failed.component.html",
})
export class InvoicedPaymentFailedAlertComponent implements OnInit {
  public show: boolean;

  constructor(private accountService: AccountService) {}

  public ngOnInit() {
    this.show = false;

    this.accountService.properties().subscribe((props: any) => {
      this.show = props.alerts.invoiced_payment_failed_alert;
      console.log("invoiced alert: " + props.alerts.invoiced_payment_failed_alert);
    });
  }
}
